import apiClient from '../axios';
import { UserReactionRequest } from '../types/Reaction.api.type';

export const reactionApi = {
  userReaction: (questionId: string, params: UserReactionRequest) => {
    return apiClient.post(`/api/reaction/userReaction/${questionId}`, params);
  },
};
